import { AppNode } from "@features/builder/graph/types"
import { nodesGroupMapper } from "@features/builder/helpers/nodesGroupMapper"
import { InfoBox } from "@features/builder/TopActionBar/SearchPooper/InfoBox"
import SearchTabButtons from "@features/builder/TopActionBar/SearchPooper/SearchTabButtons"

import { Delete, FilterList, HelpOutline } from "@mui/icons-material"
import { Button, Grid, Stack, TextField, Tooltip } from "@mui/material"
import { SearchType, searchNodes } from "@utils/node/search"
import { useReactFlow } from "@xyflow/react"
import { useRef, useState } from "react"

type FilterSectionProps = {
  onFilter: (filteredNodes: AppNode[]) => void
}

const FilterSection = (props: FilterSectionProps) => {
  const searchInputRef = useRef<HTMLInputElement>(null)
  const { getNodes } = useReactFlow<AppNode>()
  const [searchType, setSearchType] = useState<SearchType>("label")

  const handleFilter = () => {
    const searchValue = searchInputRef.current?.value || ""

    // no search value, reset to all nodes
    if (!searchValue) {
      props.onFilter(getNodes())
      return
    }

    const allNodes = getNodes()
    const mapper = nodesGroupMapper(allNodes)

    const filteredNodesIds = searchNodes(mapper, searchType, searchValue).map((n) => n.nodeId)
    const filteredNodes = allNodes.filter((n) => filteredNodesIds.includes(n.id))

    props.onFilter(filteredNodes)
  }

  const handleResetFilters = () => {
    if (searchInputRef.current) searchInputRef.current.value = ""

    setSearchType("label")
    props.onFilter(getNodes())
  }

  return (
    <Stack>
      <SearchTabButtons value={searchType} onChange={setSearchType} />
      <TextField
        size="small"
        placeholder={`Filter by ${searchType}`}
        inputRef={searchInputRef}
        InputProps={{
          endAdornment: (
            <Tooltip title={<InfoBox />}>
              <HelpOutline fontSize="small" sx={{ cursor: "pointer" }} />
            </Tooltip>
          ),
        }}
      />

      <Grid container sx={{ mt: 1 }} gap={1} wrap="nowrap">
        <Grid item xs>
          <Button variant="contained" startIcon={<FilterList />} onClick={handleFilter} fullWidth>
            Filter
          </Button>
        </Grid>
        <Grid item xs="auto" alignSelf="center">
          <Tooltip title="Reset filters">
            <Button variant="contained" color="error" onClick={handleResetFilters}>
              <Delete />
            </Button>
          </Tooltip>
        </Grid>
      </Grid>
    </Stack>
  )
}

export default FilterSection
